"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/whyChooseSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type WhyChooseSectionChooseNineFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" */
    dataWowDuration: string;
    /** Detected variants: "Medical & Non-Medical Services" | "Modern Monitoring & Health Tracking" */
    h30Text: ReactNode;
    /** Detected variants: "From nursing and therapy to companionship and daily assistance" | "Technology-enabled tracking, digital reports, medication reminders" */
    p0Text: ReactNode;
    /** Detected variants: "choose-item-nine wow fadeInUp" */
    className?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
};

type WhyChooseSectionChooseNineRightFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" */
    dataWowDuration: string;
    /** Detected variants: "Family-Centered Care Approach" | "24/7 Support & Emergency" */
    h30Text: ReactNode;
    /** Detected variants: "We focus on comfort, dignity, independence, and building trust" | "Round-the-clock care, monitoring, and helpline for safety at all times." */
    p0Text: ReactNode;
    /** Detected variants: "choose-item-nine right-item wow fadeInUp" */
    className?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
};

type WhyChooseSection466sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/icons/step-icon-1.png" | "/Templates/Doccure/img/icons/step-icon-2.png" | "/Templates/Doccure/img/icons/step-icon-3.png" */
    src: string;
    /** Detected variants: "Select Your Service" | "Choose Date & Time" | "Care Begins at Home" */
    h30Text: ReactNode;
    /** Detected variants: "Choose from nursing care, elder care, therapy, or medical assistance your specific needs." | "Pick your preferred date and time , and we’ll certified caregiver and share booking details." | "Our professional caregiver arrives at your location and starts personalized care with full support." */
    p0Text: ReactNode;
    /** Detected variants: "Step 1" | "Step 2" | "Step 3" */
    span0Text: ReactNode;
    /** Detected variants: "col-lg-4 col-md-6 col-sm-6" */
    className?: string;
    /** Detected variants: "choose-step wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "step-icon" */
    div0ClassName2?: string;
    /** Detected variants: "choose-img" */
    alt?: string;
    /** Detected variants: "img-fluid bg-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/bg/choose-step-bg.png" */
    imageWithBasePath0Src?: string;
    /** Detected variants: "choose-img" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid icon" */
    imageWithBasePath1ClassName?: string;
    /** Detected variants: "step-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "level" */
    span0ClassName?: string;
};
export type HomeNineWhyChooseSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WhyChooseSection466sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WhyChooseSection466sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSection466sItem) => Partial<ComponentProps<"h3">>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSectionChooseNineFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    whyChooseSectionChooseNineRightFadeInUpsDivH30H3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSectionChooseNineRightFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "WHY CHOOSE US" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Your" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Homecare Partner" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Trusted" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "choose-img" */
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/choose-img-one.jpg" */
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "video" */
    sectionDiv0Div1Div1Div0Video0VideoId?: string;
    /** Default: "Your browser does not support the video tag." */
    sectionDiv0Div1Div1Div0Video0VideoText?: ReactNode;
    /** Default: "/Templates/Doccure/img/video/video.mp4" */
    sectionDiv0Div1Div1Div0Video0Source0SourceSrc?: string;
    sectionDiv0Div2ClassName?: string;
    /** Default: "choose" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/choose-bg-5.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    whyChooseSectionChooseNineFadeInUps: WhyChooseSectionChooseNineFadeInUpsItem[];
    whyChooseSectionChooseNineRightFadeInUps: WhyChooseSectionChooseNineRightFadeInUpsItem[];
    whyChooseSection466s: WhyChooseSection466sItem[];
    whyChooseSectionChooseNineFadeInUpsItemWrapper?: (item: WhyChooseSectionChooseNineFadeInUpsItem, content: ReactNode) => ReactNode;
    whyChooseSectionChooseNineFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    whyChooseSectionChooseNineFadeInUpsH3Visible?: boolean;
    whyChooseSectionChooseNineFadeInUpsH3Renderer?: (item: WhyChooseSectionChooseNineFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    whyChooseSectionChooseNineFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSectionChooseNineFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    whyChooseSectionChooseNineRightFadeInUpsItemWrapper?: (item: WhyChooseSectionChooseNineRightFadeInUpsItem, content: ReactNode) => ReactNode;
    whyChooseSectionChooseNineRightFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    whyChooseSectionChooseNineRightFadeInUpsH3Visible?: boolean;
    whyChooseSectionChooseNineRightFadeInUpsH3Renderer?: (item: WhyChooseSectionChooseNineRightFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    whyChooseSectionChooseNineRightFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSectionChooseNineRightFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    whyChooseSection466sItemWrapper?: (item: WhyChooseSection466sItem, content: ReactNode) => ReactNode;
    whyChooseSection466sRenderer?: (defaultNode: ReactNode) => ReactNode;
    whyChooseSection466sImageVisible?: boolean;
    whyChooseSection466sImageRenderer?: (item: WhyChooseSection466sItem, defaultNode: ReactNode) => ReactNode;
    whyChooseSection466sH3Visible?: boolean;
    whyChooseSection466sH3Renderer?: (item: WhyChooseSection466sItem, defaultNode: ReactNode) => ReactNode;
    whyChooseSection466sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: WhyChooseSection466sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    whyChooseSection466sH3Props?: Partial<ComponentProps<"h3">> | ((item: WhyChooseSection466sItem) => Partial<ComponentProps<"h3">>);
};

const HomeNineWhyChooseSectionGenerated: FC<HomeNineWhyChooseSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "WHY CHOOSE US",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Your",
    sectionDiv0Div0H20H2Text2 = "Homecare Partner",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Trusted",
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageAlt = "choose-img",
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/choose-img-one.jpg",
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div1Div0Video0Source0SourceSrc = "/Templates/Doccure/img/video/video.mp4",
    sectionDiv0Div1Div1Div0Video0VideoId = "video",
    sectionDiv0Div1Div1Div0Video0VideoText = "Your browser does not support the video tag.",
    sectionImageWithBasePath0ImageAlt = "choose",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/choose-bg-5.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath1ImageProps,
    divDiv0Div1H30H3Props,
    divH30H3Props,
    whyChooseSectionChooseNineRightFadeInUpsDivH30H3Props,
    sectionDiv0Div1ClassName,
    sectionDiv0Div2ClassName,
    whyChooseSectionChooseNineFadeInUps,
    whyChooseSectionChooseNineRightFadeInUps,
    whyChooseSection466s,
    whyChooseSectionChooseNineFadeInUpsItemWrapper,
    whyChooseSectionChooseNineFadeInUpsRenderer,
    whyChooseSectionChooseNineFadeInUpsH3Visible,
    whyChooseSectionChooseNineFadeInUpsH3Renderer,
    whyChooseSectionChooseNineFadeInUpsH3Props,
    whyChooseSectionChooseNineRightFadeInUpsItemWrapper,
    whyChooseSectionChooseNineRightFadeInUpsRenderer,
    whyChooseSectionChooseNineRightFadeInUpsH3Visible,
    whyChooseSectionChooseNineRightFadeInUpsH3Renderer,
    whyChooseSectionChooseNineRightFadeInUpsH3Props,
    whyChooseSection466sItemWrapper,
    whyChooseSection466sRenderer,
    whyChooseSection466sImageVisible,
    whyChooseSection466sImageRenderer,
    whyChooseSection466sH3Visible,
    whyChooseSection466sH3Renderer,
    whyChooseSection466sImageProps,
    whyChooseSection466sH3Props,
}) => {
    return (
        <section className="whychoose-section-nine section">
            <div className="container">
                <div className="section-header section-header-nine text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">
                        <span className="dot" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            {" "}
                            <span className="text-primary text-decoration-underline">{sectionDiv0Div0H20Span0SpanText}</span>
                            {" "}
                            {sectionDiv0Div0H20H2Text2}
                            {" "}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row"}>
                    <div className="col-lg-3">
                        {renderCollectionNode(
                            whyChooseSectionChooseNineFadeInUps,
                            (item: WhyChooseSectionChooseNineFadeInUpsItem) => (
                                <div className={item.className ?? "choose-item-nine wow fadeInUp"} data-wow-duration={item.dataWowDuration} key={item.key}>
                                    {renderItemNode(whyChooseSectionChooseNineFadeInUpsH3Visible, whyChooseSectionChooseNineFadeInUpsH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof whyChooseSectionChooseNineFadeInUpsH3Props === "function" ? whyChooseSectionChooseNineFadeInUpsH3Props(item) : (whyChooseSectionChooseNineFadeInUpsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                    <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                </div>
                            ),
                            whyChooseSectionChooseNineFadeInUpsItemWrapper,
                            whyChooseSectionChooseNineFadeInUpsRenderer
                        )}
                    </div>
                    <div className="col-lg-6">
                        <div className="choose-img-nine">
                            {renderNode(sectionDiv0Div1Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div1Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-one d-none" {...(sectionDiv0Div1Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            <video id={sectionDiv0Div1Div1Div0Video0VideoId} playsInline autoPlay muted loop>
                                <source src={sectionDiv0Div1Div1Div0Video0Source0SourceSrc} type="video/mp4" />
                                {sectionDiv0Div1Div1Div0Video0VideoText}
                            </video>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        {renderCollectionNode(
                            whyChooseSectionChooseNineRightFadeInUps,
                            (item: WhyChooseSectionChooseNineRightFadeInUpsItem) => (
                                <div className={item.className ?? "choose-item-nine right-item wow fadeInUp"} data-wow-duration={item.dataWowDuration} key={item.key}>
                                    {renderItemNode(whyChooseSectionChooseNineRightFadeInUpsH3Visible, whyChooseSectionChooseNineRightFadeInUpsH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof whyChooseSectionChooseNineRightFadeInUpsH3Props === "function" ? whyChooseSectionChooseNineRightFadeInUpsH3Props(item) : (whyChooseSectionChooseNineRightFadeInUpsH3Props ?? {}))} {...(typeof whyChooseSectionChooseNineRightFadeInUpsDivH30H3Props === "function" ? whyChooseSectionChooseNineRightFadeInUpsDivH30H3Props(item) : (whyChooseSectionChooseNineRightFadeInUpsDivH30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                    <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                </div>
                            ),
                            whyChooseSectionChooseNineRightFadeInUpsItemWrapper,
                            whyChooseSectionChooseNineRightFadeInUpsRenderer
                        )}
                    </div>
                </div>
                <div className={sectionDiv0Div2ClassName ?? "row choose-step-nine g-3 justify-content-center"}>
                    {renderCollectionNode(
                        whyChooseSection466s,
                        (item: WhyChooseSection466sItem) => (
                            <div className={item.className ?? "col-lg-4 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "choose-step wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "step-icon"}>
                                        {renderItemNode(whyChooseSection466sImageVisible, whyChooseSection466sImageRenderer, item, (
                                            <SmartImage src={item.imageWithBasePath0Src ?? "/Templates/Doccure/img/bg/choose-step-bg.png"} alt={item.alt ?? "choose-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid bg-one"} {...(typeof whyChooseSection466sImageProps === "function" ? whyChooseSection466sImageProps(item) : (whyChooseSection466sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        {renderItemNode(whyChooseSection466sImageVisible, whyChooseSection466sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.imageWithBasePath1Alt ?? "choose-img"} className={item.imageWithBasePath1ClassName ?? "img-fluid icon"} {...(typeof whyChooseSection466sImageProps === "function" ? whyChooseSection466sImageProps(item) : (whyChooseSection466sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath1ImageProps === "function" ? divDiv0Div0ImageWithBasePath1ImageProps(item) : (divDiv0Div0ImageWithBasePath1ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "step-content"}>
                                        <span className={item.span0ClassName ?? "level"}>{item.span0Text}</span>
                                        {renderItemNode(whyChooseSection466sH3Visible, whyChooseSection466sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof whyChooseSection466sH3Props === "function" ? whyChooseSection466sH3Props(item) : (whyChooseSection466sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        whyChooseSection466sItemWrapper,
                        whyChooseSection466sRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid choose-bg-5" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeNineWhyChooseSectionGenerated;
